module.exports = __webpack_public_path__ + "resources/img/img_cloud_architecture_03.dd4ecb46d69617cd8a1b005660dbc77a.png";